// extracted by mini-css-extract-plugin
module.exports = {"row":"FooterSocial_row__1KxnM","img":"FooterSocial_img__1kBQ_"};